import Logo from "./Logo";
import Header from "./Header";
import Quytrinh from "./Quytrinh";
import Taisao from "./Taisao";
import Footer from "./Footer";
import Contact from "./Contact";

export default function Homerut() {
  return (
    <div>
      <Logo />
      <Header />
      <Quytrinh />
      <Taisao />
      <Footer />
      <Contact />
    </div>
  );
}
